import React from 'react';

const Invoice = ({ row, index }) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = `${dd}/${mm}/${yyyy}`;

    console.log(row, 'rowwwwwwwwwwwwwwwwwwwwwwwwwwwwww');
    

    return (
        <div>
            <style>
                {`
                table, th, td {
                    border: 0.3px solid #272727;
                    border-collapse: collapse;
                    padding: 6px !important;
                    font-size: 8px !important;
                    font-weight: 900 !important;
                    color: #000 !important;
                }
                th{
                    text-align: center
                }
                .f-14{
                    font-size: 14px !important;
                }
                .bt {
                    border-top: none !important;
                }
                .bb {
                    border-bottom: none !important;
                }
                .bl {
                    border-left: none !important;     
                }
                .br {
                    border-right: none !important;
                }
                .bold{
                    font-weight: 700;
                }
                .w-20{
                    width: 20%;
                }
                .w-10{
                    width: 10%;
                }
                `}
            </style>
            <div style={{ width: "99%" }}>
                <h1 style={{ fontSize: '16px', textAlign: 'center' }}>TAX INVOICE</h1>

                <table style={{ width: '100%' }} key={index}>
                    <tbody>
                        <tr>
                            <td rowSpan="3" style={{ width: '50.5%' }} className='text-start'>
                                <strong>ULTRA SURFACE FINISHERS</strong>
                                <br />
                                NO:3, WELFARE SCHOOL STREET,
                                <br />
                                AYANAMBAKKAM,
                                <br />
                                CHENNAI - 600095
                                <br />
                                PH: 9884565830,9884043474
                                <br />
                                E-MAIL: usfchennai@gmail.com
                                <br />
                                GSTIN: 33AJWPP0088Q1Z9
                            </td>
                            <td>Invoice No<br /> <strong>{row?.invoiceNo}</strong></td>
                            <td>Invoice Date <br /> <strong>{formattedToday}</strong></td>
                        </tr>
                        <tr>
                            <td width='25%'>Purchase Order No. {row?.orderNo || ""}</td>
                            <td>Vendor Code</td>
                        </tr>
                        <tr>
                            <td className='br'>SAC Code<br /> <strong>998898</strong></td>
                            <td className='bl'></td>
                        </tr>
                        {/* <tr>
                            <td>Supplier's Ref</td>
                            <td>Other Reference(s)</td>
                        </tr> */}

                        <tr>
                            <td rowSpan="3" className='text-start br'>
                                <strong>BILL TO:</strong>
                                <br />
                                <strong>{row?.companyName}</strong>
                                <br />
                                {row?.doorNo}
                                <br />
                                {row?.streetName}
                                <br />
                                {row?.city} - {row?.pinCode}
                                <br />
                                GSTIN. {row?.gstNo}
                                <br />
                            </td>
                            {/* <td>Despatch Doc No.</td>
                            <td>Delivery Note Date</td> */}
                        </tr>
                        <tr>
                            {/* <td>Terms of Payment</td>
                            <td>Destination</td> */}
                        </tr>
                        <tr>
                            {/* <td colSpan="2">Terms of Delivery</td> */}
                        </tr>
                    </tbody>
                </table>

                <table style={{ width: '100%', marginTop: '12px' }}>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>USF DC NO.</th>
                            <th>DATE</th>
                            <th>COMPONENTS</th>
                            <th>CUSTOMER DC NO.</th>
                            <th>QTY (NO.S/KGS)</th>
                            <th>RATE</th>
                            <th>AMOUNT</th>
                        </tr>
                    </thead>
                    <tbody style={{ height: "400px" }} className='tr'>
                        {row?.invoiceData?.map((row, index) => (
                            <tr>
                                <td className='text-center bb bt'>{index + 1}</td>
                                <td className='text-center bb bt'>{row?.usfDCNo || ''}</td>
                                <td className='text-center bb bt'>{row?.usfDcDate?.split('T')[0] || ''}</td>
                                <td className='bb bt' style={{ width: "20%", whiteSpace: "pre-line", fontWeight: "bold" }} >{row?.partName || ''} - {row?.partNo || ''} - {row?.description || ''}</td>
                                <td className='text-center bb bt'>{row?.customerDCNo || ''}</td>
                                <td className='text-center bb bt'><strong>{row?.outwardQuantity || ''} ({row?.units || ""})</strong></td>
                                <td className='text-center bb bt'>{row?.rate || ''}</td>
                                <td className='text-end bb bt'>{row?.amount || ''}</td>
                            </tr>
                        ))}

                        {Array.from({ length: Math.max(0, 10 - (row?.invoiceData?.length || 0)) }).map(
                            (_, index) => (
                                <tr key={`empty-${index}`}>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-center bb bt">&nbsp;</td>
                                    <td className="text-end bb bt">&nbsp;</td>
                                </tr>
                            )
                        )}
                    </tbody>
                    <tbody>

                        <tr style={{ height: "100px" }}>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='text-center bb bt'><strong>{row?.totalQuantity}</strong></td>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>{row?.totalAmount}</strong></td>
                        </tr>

                        <tr>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>CGST Outward 9%</strong></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>{row?.cgst}</strong></td>
                        </tr>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>SGST Outward 9%</strong></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>{row?.sgst}</strong></td>
                        </tr>
                        <tr>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>IGST Outward 18%</strong></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='bb bt'></td>
                            <td className='text-end bb bt'><strong>{row?.igst}</strong></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td className='text-end'><strong>Total</strong></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='text-end'><strong>₹. {row?.grandTotal}</strong></td>
                        </tr>
                        <tr>
                            <td colSpan="8">
                                Tax Amount (in words):
                                <br />
                                <strong>{row?.grandTotalInWords?.toUpperCase() || ""} ONLY</strong>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table style={{ width: '100%', marginTop: '2px' }}>
                    <tbody>
                        <tr>
                            <td colSpan="5" style={{ width: '50%' }} className='bt br bb'>
                                <strong>Company's GST No.</strong> : 33AJWPP0088Q1Z9
                            </td>
                            <td colSpan="4" className='bt bl bb'>
                                <strong>Company's Bank Details</strong>
                                <br />
                                <strong>Bank Name :</strong> INDIAN OVERSEAS BANK<br /> (NOLAMBUR BRANCH)
                                <br />
                                <strong>A/c No. :</strong> 213902000100020
                                <br />
                                <strong>Branch & IFS Code :</strong> IOBA0002139
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="5" className='bt'>
                                <strong>Declaration</strong>
                                <br />
                                We declare that this invoice shows the actual price of the goods<br /> described and that all particulars are true and correct.
                            </td>
                            <td colSpan="4" style={{ height: '56px' }}>
                                <strong>
                                    <p>FOR ULTRA SURFACE FINISHERS</p>
                                    <br />
                                    Authorised Signatory
                                </strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p className='f-13 text-center mt-2 text-bold'>This is a computer Generated Invoice</p>
            </div>
        </div>
    );
};

export default Invoice;
